if (!customElements.get('delyme-deal-row')) {
  customElements.define('delyme-deal-row', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      this.row = this.querySelector('.dm-offer-row');
      this.buttons = [...this.querySelectorAll('[data-direction]')];
      if (!this.row) return;
      const options = { signal: this.events.signal };
      this.update = () => {
        const end = this.row.scrollWidth - this.row.clientWidth;
        this.buttons.forEach(button => {
          button.hidden = end < 2 || (Number(button.dataset.direction) < 0 ? this.row.scrollLeft < 5 : this.row.scrollLeft >= end - 5);
        });
      };
      this.buttons.forEach(button => button.addEventListener('click', () => {
        const step = this.row.firstElementChild?.getBoundingClientRect().width || this.row.clientWidth;
        const gap = parseFloat(getComputedStyle(this.row).columnGap) || 0;
        this.row.scrollBy({ left: Number(button.dataset.direction) * (step + gap), behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth' });
      }, options));
      this.row.addEventListener('scroll', this.update, { ...options, passive: true });
      this.observer?.disconnect();
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.row);
      this.update();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
    }
  });
}
